interface IDetailsModalActionBarProps {
  cancelText?: string
  cancel: () => void
}

/**
 * Modal Action Bar with following content that is in most "Details" modals
 * | DONE |
 */
const DetailsModalActionBar = ({
  cancelText = 'DONE',
  cancel
}: IDetailsModalActionBarProps) => {
  /**
   * NOTE: This component is currently only used in DetailsModal, so h-14 is set directly here.
   * If you need to use DetailsModalActionBar elsewhere with a different height or styling,
   * please refactor to accept className as a prop so each scenario can apply its own styles.
   */
  return (
    <div className='flex px-5 py-3 h-14 items-center'>
      <button
        className={[
          'ml-auto px-4 py-2 h-10',
          'rounded border border-lighthouseBlue',
          'text-lighthouseBlue',
          'font-medium'
        ].join(' ')}
        onClick={cancel}
      >
        {cancelText}
      </button>
    </div>
  )
}

export default DetailsModalActionBar
